import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { CalloutComponent } from '@shared/components/callout/callout.component';
import { TuiButton } from '@taiga-ui/core';
import { FormIconPipe } from '../../pipes/form-icon.pipe';
import { FormTriggerBase } from '../form-trigger-base';

/**
 * Renders MANUAL modules as user actions (buttons), section-scoped. Engine-driven
 * AUTO modules are handled by {@link FormAutoTriggerComponent} at the form root.
 */
@Component({
  selector: 'pxc-form-manual-trigger',
  imports: [CommonModule, TuiButton, TranslocoDirective, FormIconPipe, CalloutComponent],
  host: {
    class: 'flex flex-col gap-4',
  },
  templateUrl: './form-manual-trigger.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormManualTriggerComponent extends FormTriggerBase {}
